import React from 'react';
const bonuses = [{
  title: 'FUNCTIONAL CLASS VAULT™',
  description: '100 lezioni complete già pronte da utilizzare, adattabili a qualsiasi livello di esperienza.'
}, {
  title: 'FUNCTIONAL EXERCISE ATLAS™',
  description: 'Atlante illustrato con oltre 300 esercizi funzionali, progressioni, regressioni e varianti.'
}, {
  title: '52 WEEKS OF FUNCTIONAL TRAINING™',
  description: 'Un anno completo di programmazione con temi settimanali e idee già organizzate.'
}, {
  title: 'FUNCTIONAL COACH TOOLKIT™',
  description: "Schede professionali, valutazioni, monitoraggio dei progressi e strumenti pronti all'uso."
}, {
  title: 'VISUAL CUEING MASTERPACK™',
  description: 'Guide visuali, correzioni tecniche e cue professionali per migliorare immediatamente il coaching.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Risparmia Ore Ogni Settimana',
  desc: 'Smetti di creare allenamenti da zero. Apri il sistema, scegli la sessione e insegna.'
}, {
  emoji: '👑',
  title: 'Maggiore Sicurezza Professionale',
  desc: 'Saprai sempre cosa insegnare, come programmare e come adattare gli allenamenti ai tuoi clienti.'
}, {
  emoji: '💪',
  title: 'Risultati Migliori per i Clienti',
  desc: 'Programmi più strutturati, progressioni più efficaci e allenamenti più professionali.'
}, {
  emoji: '😊',
  title: 'Maggiore Coinvolgimento e Fidelizzazione',
  desc: 'Mantieni alta la motivazione grazie a lezioni sempre diverse e ben organizzate.'
}];
export function BonusSection() {
  return <>
      <section className="py-10 px-5 bg-petrol text-white" data-id="element-15">
        <div className="text-center mb-8" data-id="element-16">
          <h2 className="text-2xl font-heading font-bold mb-3 text-gold" data-id="element-17">
            5 BONUS PREMIUM INCLUSI
          </h2>
          <p className="text-sm font-body mb-4" data-id="element-18">
            Inoltre riceverai 5 Bonus Premium esclusivi.
          </p>
          <p className="text-sm text-cream/80" data-id="element-19">
            Risorse professionali progettate per farti risparmiare ancora più
            tempo e migliorare l'esperienza dei tuoi clienti.
          </p>
        </div>

        <div className="flex flex-col gap-4 mb-8" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#172D42] p-4 border border-gold/30" data-id="element-21">
              <div className="text-gold font-subheading font-bold text-xs mb-2" data-id="element-22">
                🎁 BONUS {i + 1} — GRATUITO
              </div>
              <h3 className="text-base font-bold text-white mb-1 font-subheading" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-sm text-cream/80" data-id="element-24">{bonus.description}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-25">
          <p className="font-subheading font-bold text-gold text-sm" data-id="element-26">
            Tutti e 5 i Bonus sono inclusi GRATUITAMENTE con il tuo acquisto di
            oggi.
          </p>
        </div>
      </section>

      <section className="py-10 px-5 bg-cream" data-id="element-27">
        <h2 className="text-2xl font-heading font-bold text-center text-petrol mb-2" data-id="element-28">
          COSA CAMBIERÀ NELLA TUA VITA PROFESSIONALE
        </h2>
        <p className="text-sm text-center text-graphite mb-8 font-bold" data-id="element-29">
          Benefici reali fin dalla prima settimana.
        </p>

        <div className="flex flex-col gap-4" data-id="element-30">
          {benefits.map((item, i) => <div key={i} className="bg-white p-4 border-l-4 border-sage flex gap-3" data-id="element-31">
              <div className="text-2xl" data-id="element-32">{item.emoji}</div>
              <div data-id="element-33">
                <h3 className="text-sm font-bold text-petrol mb-1 font-subheading" data-id="element-34">
                  {item.title}
                </h3>
                <p className="text-graphite text-sm" data-id="element-35">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}